import * as React from 'react';

import { cn } from '../../lib/utils.js';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {}

export function Badge({ className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider bg-brand-strong text-white rounded select-none whitespace-nowrap',
        className,
      )}
      {...props}
    />
  );
}
